// frontend/apps/widgets/src/widgets/TableReservation/components/ConfigurationError.js
import React from 'react';
import PropTypes from 'prop-types';

// @mui
import {styled} from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';

// Styled components
const ErrorContainer = styled(Paper)(({theme}) => ({
  padding: theme.spacing(4),
  textAlign: 'center',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: 'none',
}));

const IconWrapper = styled(Box)(({theme}) => ({
  marginBottom: theme.spacing(2),
  color: theme.palette.error.main,
}));

/**
 * Composant pour afficher une erreur de configuration du widget
 *
 * @return {JSX.Element} Un composant React affichant une erreur de configuration.
 */
export function ConfigurationError({
  title,
  message,
  details,
  onClose,
  showCloseButton = false,
}) {
  return (
    <ErrorContainer elevation={0}>
      <IconWrapper>
        <SentimentDissatisfiedIcon sx={{fontSize: 64}} />
      </IconWrapper>

      <Typography variant="h5" gutterBottom fontWeight="medium">
        {title}
      </Typography>

      <Typography variant="body1" paragraph>
        {message}
      </Typography>

      <Typography variant="body2" color="text.secondary" paragraph>
        {details}
      </Typography>

      <Typography variant="caption" color="text.secondary" sx={{mt: 1}}>
        Si le problème persiste, veuillez contacter l&apos;administrateur du site.
      </Typography>

      {showCloseButton && (
        <Box sx={{mt: 3}}>
          <Button
            variant="outlined"
            color="primary"
            onClick={onClose}
          >
            Fermer
          </Button>
        </Box>
      )}
    </ErrorContainer>
  );
}

ConfigurationError.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  details: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  showCloseButton: PropTypes.bool,
};
